import { render, staticRenderFns } from "./OsNumeros2025.vue?vue&type=template&id=42127d72&scoped=true&"
import script from "./OsNumeros2025.vue?vue&type=script&lang=js&"
export * from "./OsNumeros2025.vue?vue&type=script&lang=js&"
import style0 from "./OsNumeros2025.vue?vue&type=style&index=0&id=42127d72&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42127d72",
  null
  
)

export default component.exports